import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setMonitoringDetails } from '@/redux/monitoring/monitoringSlice';

import monitoringService from '@/services/monitoringService';

const getMonitoringDetails = id => async dispatch => {
  try {
    const response = await monitoringService.getMonitoringDetails(id);

    dispatch(setMonitoringDetails(response.data.data));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request GetMonitoringDetails failure',
    );
  }
};

export default {
  getMonitoringDetails,
};
